
import { create } from "zustand";
import { API_BASE_URL1, API_BASE_URL } from "../../../../Services/baseApiUrl";
import { apiCall } from "../../../../../utils/apiCall";

const TripsAndTonnageStore = create((set, get) => ({

    tripsAndTonnageReportData: [],
    innerTripsAndTonnageReportData: [],
    loading: false,
    error: false,

    fetchTripsAndTonnageApi: async (fromDate, toDate, zoneIds,) => {
        set({ loading: true, error: null });
        try {
            let url = `${API_BASE_URL}api/SecondaryCollection/TripTonnageReport?FromDate=${fromDate}&ToDate=${toDate}`;
                    if (zoneIds && zoneIds.length > 0) {
                        url += `&ZoneIds=${zoneIds.join(',')}`;
                    }
            const reportsData = await apiCall({
                url,
                method: "get",
                token: localStorage.getItem("token"),
            });
            set({
                tripsAndTonnageReportData: Array.isArray(reportsData) ? reportsData : [],
                loading: false
            });

        } catch (error) {
            console.log(error.response?.data?.message || "Error fetching data");
            if (error.response && error.response.status === 404) {
                set({
                    tripsAndTonnageReportData: [], // fixed typo: tripsAndTonnageReportData → tripsAndTonnageReportData
                    error: "No Data found.",
                    loading: false
                });
            } else {
                set({ error: error.response?.data?.message || "Something went wrong", loading: false });
            }
        }
    },

    fetchInnerTripsAndTonnageApi: async (fromDate, toDate, zoneId,) => {
        set({ loading: true, error: null });
        try {
            const url =
                `${API_BASE_URL}api/SecondaryCollection/TonnageInnerReport?FromDate=${fromDate}&ToDate=${toDate}&ZoneId=${zoneId}`;

            const innerReportsData = await apiCall({
                url,
                method: "get",
                token: localStorage.getItem("token"),
            });
            set({
                innerTripsAndTonnageReportData: Array.isArray(innerReportsData) ? innerReportsData : [],
                loading: false
            });

        } catch (error) {
            console.log(error.response?.data?.message || "Error fetching data");
            if (error.response && error.response.status === 404) {
                set({
                    innerTripsAndTonnageReportData: [], // fixed typo: tripsAndTonnageReportData → tripsAndTonnageReportData
                    error: "No Data found.",
                    loading: false
                });
            } else {
                set({ error: error.response?.data?.message || "Something went wrong", loading: false });
            }
        }
    },
}));

export default TripsAndTonnageStore
